import { PROPERTY_TYPE_MAP, TRoomDetail } from '@/entities/room'

import { Heading, Item, Label, List, Value } from '../common'

export type Props = Pick<
  TRoomDetail,
  'propertyType' | 'pyeongSize' | 'squareMeterSize'
>

export const Property = ({
  propertyType,
  pyeongSize,
  squareMeterSize,
}: Props) => {
  return (
    <div className="w-[260px] space-y-5">
      <Heading>건물 유형 및 면적</Heading>
      <List spacing="medium" className="typo-body2 text-gray-900">
        <Item className="justify-between">
          <Label icon="propertyType" className="font-semibold">
            건물 유형
          </Label>
          <Value>{PROPERTY_TYPE_MAP[propertyType]}</Value>
        </Item>
        <Item className="justify-between">
          <Label icon="pyeongSize" className="font-semibold">
            전용 면적
          </Label>
          <Value>{`${pyeongSize}평 (${Math.round(squareMeterSize)}m²)`}</Value>
        </Item>
      </List>
    </div>
  )
}
